/* eslint-disable no-param-reassign */
import * as marietta from '../..';
import {
  BUILDING_TYPE_HOUSE,
  CONTROL_ACTIONMODE, ITEM_MODE_NAME_ENG, ITEM_MODE_NO, SITE_EDITMODE, SITE_INPUT_MODE,
} from '../Constants';
import { Fitting, MonicaObject } from '../item';

/**
 * アイテムメニューを処理するためのクラス
 */
export default class ItemMenu {
  itemManager: marietta.webcad.manager.ItemManager;

  _tempHideMenu : string = '';

  _currentMenuID: string;

  get currentMenuID() { return this._currentMenuID; }

  set currentMenuID(id: string) {
    this._currentMenuID = id;

    // カレントモードの設定
    switch (this.currentMenuID) {
      case '#itemMenu_shitae': marietta.webcad.WebCADGlobal.webcad2Dmanager.currentModeNo = ITEM_MODE_NO.MODE_SHITAE_NO; break;
      case '#itemMenu_site': marietta.webcad.WebCADGlobal.webcad2Dmanager.currentModeNo = ITEM_MODE_NO.MODE_SITE_NO; break;
      case '#itemMenu_room': marietta.webcad.WebCADGlobal.webcad2Dmanager.currentModeNo = ITEM_MODE_NO.MODE_ROOM_NO; break;
      case '#itemMenu_stair': marietta.webcad.WebCADGlobal.webcad2Dmanager.currentModeNo = ITEM_MODE_NO.MODE_STAIR_NO; break;
      case '#itemMenu_fitting': marietta.webcad.WebCADGlobal.webcad2Dmanager.currentModeNo = ITEM_MODE_NO.MODE_FITTING_NO; break;
      case '#itemMenu_equipment': marietta.webcad.WebCADGlobal.webcad2Dmanager.currentModeNo = ITEM_MODE_NO.MODE_EQUIPMENT_NO; break;
      case '#itemMenu_furniture': marietta.webcad.WebCADGlobal.webcad2Dmanager.currentModeNo = ITEM_MODE_NO.MODE_FURNITURE_NO; break;
      case '#itemMenu_exterior': marietta.webcad.WebCADGlobal.webcad2Dmanager.currentModeNo = ITEM_MODE_NO.MODE_EXTERIOR_NO; break;
      case '#itemMenu_roof': marietta.webcad.WebCADGlobal.webcad2Dmanager.currentModeNo = ITEM_MODE_NO.MODE_ROOF_NO; break;
      default: break;
    }
  }

  /**
   * アイテム作成フラグを設定します
   */
  private _itemMenuCreateFlag: boolean = false;

  get itemMenuCreateFlag(): boolean { return this._itemMenuCreateFlag; }

  set itemMenuCreateFlag(value: boolean) {
    this._itemMenuCreateFlag = value;
  }

  /**
   * コンストラクタ
   * @param marietta.webcad.manager.ItemManager
   */
  constructor(_manager: marietta.webcad.manager.ItemManager) {
    this.itemManager = _manager;
    const self = this;

    // セレクトボックスイベント
    document.querySelectorAll('.variationList').forEach((element) => {
      element.addEventListener('click', self.updateItemList);
    });

    // 連続入力モードイベント
    if (document.getElementById('checkContinualInput') != null) {
      document.getElementById('checkContinualInput').addEventListener('change', () => {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.continualInput = (<HTMLInputElement>document.getElementById('checkContinualInput')).checked;
      });
    }

    // アクションモード変更イベント
    document.querySelectorAll('.itemMenu').forEach((element) => {
      element.querySelectorAll('label').forEach((elem) => {
        elem.addEventListener('click', (e) => {
        // marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
        // marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;

          let currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
          let currentSiteEditMode = null;
          let isSiteInputChange = true;
          if ((e.currentTarget as HTMLElement).previousElementSibling !== null) {
            switch ((e.currentTarget as HTMLElement).previousElementSibling.getAttribute('id')) {
              case 'btnEditSiteFree':
                currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_SITE;
                if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE) {
                  const tarLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_SITE_NO);
                  if (tarLayer.getAllChildren().length > 0) {
                    isSiteInputChange = false;
                    marietta.webcad.WebCADGlobal.showConfirmDialog('現在の敷地は削除されます。\nよろしいですか？', '入力方法変更', () => {
                      tarLayer.initMe();
                      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = SITE_INPUT_MODE.SITE_SIMPLE_INPUT_MODE;
                      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteEditMode = SITE_EDITMODE.SITE_EDIT_FREE_INPUT;
                    }, () => {
                      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE;
                      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_SITE;
                      (<HTMLInputElement>document.getElementById('btnEditSiteTrianglular')).checked = true;
                    }, false);
                  }
                }
                if (isSiteInputChange) {
                  marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = SITE_INPUT_MODE.SITE_SIMPLE_INPUT_MODE;
                  currentSiteEditMode = SITE_EDITMODE.SITE_EDIT_FREE_INPUT;
                }
                break;
              case 'btnEditSiteCoordinate':
                currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_SITE;
                if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE) {
                  const tarLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_SITE_NO);
                  if (tarLayer.getAllChildren().length > 0) {
                    isSiteInputChange = false;
                    marietta.webcad.WebCADGlobal.showConfirmDialog('現在の敷地は削除されます。\nよろしいですか？', '入力方法変更', () => {
                      tarLayer.initMe();
                      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = SITE_INPUT_MODE.SITE_SIMPLE_INPUT_MODE;
                      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteEditMode = SITE_EDITMODE.SITE_EDIT_COORDINATE_INPUT;
                                  marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.SiteCoordinateinputDialog, true, true, false, true) as marietta.webcad.view.dialog.SiteCoordinateinputDialog;
                    }, () => {
                      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE;
                      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_SITE;
                      (<HTMLInputElement>document.getElementById('btnEditSiteTrianglular')).checked = true;
                    }, false);
                  }
                }
                if (isSiteInputChange) {
                  marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = SITE_INPUT_MODE.SITE_SIMPLE_INPUT_MODE;
                  currentSiteEditMode = SITE_EDITMODE.SITE_EDIT_COORDINATE_INPUT;
                          marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.SiteCoordinateinputDialog, true, true, false, true) as marietta.webcad.view.dialog.SiteCoordinateinputDialog;
                }
                break;
              case 'btnEditSiteTrianglular':
                currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_SITE;
                if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode === SITE_INPUT_MODE.SITE_SIMPLE_INPUT_MODE) {
                  const tarLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_SITE_NO);
                  if (tarLayer.getAllChildren().length > 0) {
                    isSiteInputChange = false;
                    marietta.webcad.WebCADGlobal.showConfirmDialog('現在の敷地は削除されます。\nよろしいですか？', '入力方法変更', () => {
                      tarLayer.initMe();
                      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE;
                      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteEditMode = SITE_EDITMODE.SITE_EDIT_TRIANGULAR_INPUT;
                    }, () => {
                      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = SITE_INPUT_MODE.SITE_SIMPLE_INPUT_MODE;
                      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_SITE;
                      (<HTMLInputElement>document.getElementById('btnEditSiteFree')).checked = true;
                    }, false);
                  }
                }
                if (isSiteInputChange) {
                  marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE;
                  currentSiteEditMode = SITE_EDITMODE.SITE_EDIT_TRIANGULAR_INPUT;
                }
                break;
              case 'btnRoomSelect':
                currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
                document.getElementById('roomInputMenuItems').style.display = 'none';
                break;
              case 'btnRoomDragInput':
                currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_DRAG_ROOM;
                document.getElementById('btnRoomDragInput').style.display = '';
                break;
              case 'btnRoomKakomiInput':
                currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_ROOM;
                document.getElementById('roomInputMenuItems').style.display = '';
                break;
              case 'btnRoomSketchInput':
                if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.hasShownSketchInstruction) {
                  currentActionMode = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentModeNo;
                  marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.SketchInputInstructionDialog, false, true, false);
                } else {
                  currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_ROOM_SKETCH;
                }
                document.getElementById('roomInputMenuItems').style.display = '';
                break;
              case 'btnFittingSelect':
                currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
                document.getElementById('fittingVariationList').style.display = 'none';
                // value is undefined
                // $(this).parents('.itemMenuHeader').next('.menuFrame').hide();
                break;
              case 'btnFittingDragInput':
                currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_DRAG_FITTING;
                // fittingVariationList is not using
                // document.getElementById('fittingVariationList').style.display = 'none';
                // value is undefined
                (<HTMLElement>document.querySelector(this.currentMenuID).querySelector('.menuFrame')).style.display = 'none';
                break;
              case 'btnFittingPut':
                currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
                // fittingVariationList is not using
                // document.getElementById('fittingVariationList').style.display = '';
                // value is undefined
                (<HTMLElement>document.querySelector(this.currentMenuID).querySelector('.menuFrame')).style.display = 'block';
                break;
              case 'btnTextInput':
                currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_FREE_CHARACTER;
                break;
              case 'btnPinTextInput':
                currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_PIN_TEXT;
                break;
              case 'btnPinTextInput360':
                currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_PIN_PANORAMA;
                break;
              default:
                currentActionMode = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode;
                break;
            }
          }
          marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = currentActionMode;

          if (currentSiteEditMode != null && currentActionMode !== CONTROL_ACTIONMODE.ACTIONMODE_SELECT_SITE) {
            marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteEditMode = currentSiteEditMode;
          }
        });
      });
    });

    // 部屋種類ボタンイベント
    if (marietta.webcad.WebCADGlobal.userAgentManager.isPC) {
      document.getElementById('roomInputMenuItems').querySelectorAll('label').forEach((element) => {
        if (element.getAttribute('id') !== 'continuesInp') {
          element.addEventListener('mouseover', () => {
            if (!(<HTMLInputElement>element.previousElementSibling).disabled) {
              element.classList.add('is-active');
            }
          });
          element.addEventListener('mouseout', () => {
            element.classList.remove('is-active');
          });
        }
      });
    }
    document.getElementById('roomInputMenuItems').querySelectorAll('label').forEach((_element) => {
      const element = _element;
      if (element.getAttribute('id') !== 'continuesInp') {
        element.addEventListener('click', () => {
          // 非アクティブ時はスキップ
          if (element.classList.contains('notAllowed')) return;
          // アクションモードの設定
          if ((<HTMLInputElement>element.previousElementSibling).value === 'kabe') {
            marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
            document.querySelectorAll('input[name="roomInputMode"]').forEach((elem : HTMLInputElement) => {
              elem.disabled = true;
              elem.checked = false;
            });

            if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_HOUSE) {
              const info = new marietta.webcad.collection.ItemInfoCollection();
              info.id = 'fit01_01';
              info.guid = marietta.webcad.WebCADGlobal.getGuid();
              const item = marietta.webcad.WebCADGlobal.LIBRARY_ITEMSLIST.get(info.id);
              info.width = 120;
              if (item) {
                if (item.width) info.width = Number(item.width);
                if (item.widthmm)info.widthmm = Number(item.widthmm);
              }
              info.rotation = 0;
              if (!marietta.webcad.WebCADGlobal.userAgentManager.isPC) {
                marietta.webcad.WebCADGlobal.webcad2Dmanager.inputCallback = (centerPoint: marietta.core.Point) => {
                  info.x = centerPoint.x;
                  info.y = centerPoint.y;
                  self.itemManager.createItem(info);

                  //見積リスト更新
                  marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();

                  marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
                };
                marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_TOUCH_MOBILE;
              } else {
                self.itemManager.createItem(info);
              }
            } else {
              marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_WALL;
            }
          } else {
            let checked = false;
            document.querySelectorAll('input[name="roomInputMode"]').forEach((elem : HTMLInputElement) => {
              elem.disabled = false;
              if (elem.checked) checked = true;
            });
            if (!checked)(<HTMLInputElement>document.getElementById('btnRoomKakomiInput')).checked = true;
            (<HTMLInputElement>element.previousElementSibling).checked = true;
            marietta.webcad.WebCADGlobal.webcad2Dmanager.updatecurrentActionModeFromItemMenu();
          }
        });
      }
    });
    document.querySelectorAll('.itemMenuBtns').forEach((element) => {
      element.querySelectorAll('button').forEach((elem) => {
        elem.addEventListener('click', (e) => {
          if ((<HTMLElement>(e.currentTarget)).getAttribute('id').indexOf('rom') > -1) return;
          self._tempHideMenu = self.currentMenuID;
          let info: marietta.webcad.collection.ItemInfoCollection;

          // メニューから作成されたアイテムのアイテム作成フラグを有効にする
          marietta.WebCADGlobal.itemMenu.itemMenuCreateFlag = true;
          console.log((<HTMLElement>(e.currentTarget)).getAttribute('id').indexOf('set'));
          // セットの場合
          if ((<HTMLElement>(e.currentTarget)).getAttribute('id').indexOf('set') > -1) {
            let target;
            for (let i: number = 0; i < marietta.webcad.WebCADGlobal.LIBRARY_SETITEMS.length; i += 1) {
              if ((<HTMLElement>(e.currentTarget)).getAttribute('id') === marietta.webcad.WebCADGlobal.LIBRARY_SETITEMS[i].id) {
                target = marietta.webcad.WebCADGlobal.LIBRARY_SETITEMS[i];
                break;
              }
            }
            if (target === undefined || target == null) return;
            const items = target.itemList;
            const itemsCreated = [];

            let pointX: number;
            let pointY: number;

            if (marietta.webcad.WebCADGlobal.userAgentManager.isPC) {
              pointX = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX;
              pointY = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY;
              // セット家具の相対オフセットはMODULE_PITCH_DEFAULT基準の固定px値のため、現在のモジュールピッチとの比率で補正する
              const offsetPitchRatio: number = marietta.webcad.WebCADGlobal.MODULE_PITCH_DEFAULT
                / marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch;
              for (let i = 0; i < items.length; i += 1) {
                info = new marietta.webcad.collection.ItemInfoCollection();
                info.id = items[i].id;
                info.guid = marietta.webcad.WebCADGlobal.getGuid();
                info.widthmm = parseInt(items[i].width, 10);
                info.heightmm = parseInt(items[i].depth, 10);
                info.x = pointX + parseInt(items[i].x, 10) * offsetPitchRatio;
                info.y = pointY - parseInt(items[i].y, 10) * offsetPitchRatio;
                if (info.id.substring(0, 3) === 'fur' || info.id.substring(0, 3) === 'equ' || info.id.substring(0, 3) === 'ext' || info.id.substring(0, 3) === 'fit') {
                  info.z = items[i].z ? Number(items[i].z) : 0;
                  const item = marietta.webcad.WebCADGlobal.LIBRARY_ITEMSLIST.get(info.id);
                  info.text = marietta.webcad.WebCADGlobal.language === 'jp' ? item.name.substring(0, 10) : item.name_en.substring(0, 10);
                }
                if (marietta.webcad.WebCADGlobal.ceilingItemCodeList.includes(info.id)) info.is_ceiling_item = true;
                info.rotation = parseInt(items[i].rotation, 10);
                itemsCreated.push(self.itemManager.createItem(info));
                // self.itemManager.createItem(info)
              }

              // 選択できたアイテムをグループ化
              marietta.webcad.WebCADGlobal.itemManager.addItems(itemsCreated);

              if (marietta.webcad.WebCADGlobal.userAgentManager.isPC) marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.startFollowMouse();
            } else {
              // //表示中のステージ中央座標を取得
              // var centerPoint: marietta.core.Point = marietta.webcad.util.WebCADUtil.getPointStageCenter();

              // //座標をグリッドにスナップさせる
              // var snap_unit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
              // pointX = Math.round(centerPoint.x / snap_unit) * snap_unit;
              // pointY = Math.round(centerPoint.y / snap_unit) * snap_unit;
              marietta.webcad.WebCADGlobal.webcad2Dmanager.inputCallback = (centerPoint: marietta.core.Point) => {
                pointX = centerPoint.x;
                pointY = centerPoint.y;
                // セット家具の相対オフセットはMODULE_PITCH_DEFAULT基準の固定px値のため、現在のモジュールピッチとの比率で補正する
                const offsetPitchRatio: number = marietta.webcad.WebCADGlobal.MODULE_PITCH_DEFAULT
                  / marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch;
                for (let i = 0; i < items.length; i += 1) {
                  info = new marietta.webcad.collection.ItemInfoCollection();
                  info.id = items[i].id;
                  info.guid = marietta.webcad.WebCADGlobal.getGuid();
                  info.widthmm = parseInt(items[i].width, 10);
                  info.heightmm = parseInt(items[i].depth, 10);
                  info.x = pointX + parseInt(items[i].x, 10) * offsetPitchRatio;
                  info.y = pointY - parseInt(items[i].y, 10) * offsetPitchRatio;
                  info.rotation = parseInt(items[i].rotation, 10);
                  if (info.id.substring(0, 3) === 'fur' || info.id.substring(0, 3) === 'equ' || info.id.substring(0, 3) === 'ext' || info.id.substring(0, 3) === 'fit') {
                    info.z = items[i].z ? Number(items[i].z) : 0;
                    const item = marietta.webcad.WebCADGlobal.LIBRARY_ITEMSLIST.get(info.id);
                    info.text = marietta.webcad.WebCADGlobal.language === 'jp' ? item.name.substring(0, 10) : item.name_en.substring(0, 10);
                  }
                  if (marietta.webcad.WebCADGlobal.ceilingItemCodeList.includes(info.id)) info.is_ceiling_item = true;
                  itemsCreated.push(self.itemManager.createItem(info));
                  // self.itemManager.createItem(info)
                }
                // 選択できたアイテムをグループ化
                marietta.webcad.WebCADGlobal.itemManager.addItems(itemsCreated);
                marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
              };

              marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_TOUCH_MOBILE;
            }
          } else {
            info = new marietta.webcad.collection.ItemInfoCollection();
            info.id = (<HTMLElement>(e.currentTarget)).getAttribute('id');
            info.guid = marietta.webcad.WebCADGlobal.getGuid();
            if (marietta.webcad.WebCADGlobal.ceilingItemCodeList.includes(info.id)) info.is_ceiling_item = true;
            if ((<HTMLElement>(e.currentTarget)).getAttribute('data-item_widthmm')) info.widthmm = Number((<HTMLElement>(e.currentTarget)).getAttribute('data-item_widthmm'));
            if ((<HTMLElement>(e.currentTarget)).getAttribute('data-item_depthmm')) info.heightmm = Number((<HTMLElement>(e.currentTarget)).getAttribute('data-item_depthmm'));
            if ((<HTMLElement>(e.currentTarget)).getAttribute('data-item_width')) info.width = Number((<HTMLElement>(e.currentTarget)).getAttribute('data-item_width'));
            if ((<HTMLElement>(e.currentTarget)).getAttribute('data-item_depth')) info.height = Number((<HTMLElement>(e.currentTarget)).getAttribute('data-item_depth'));
            if ((<HTMLElement>(e.currentTarget)).getAttribute('data-item_fitting_height')) info.fitting_height = Number((<HTMLElement>(e.currentTarget)).getAttribute('data-item_fitting_height'));

            if (info.id.substring(0, 3) === 'fur' || info.id.substring(0, 3) === 'equ' || info.id.substring(0, 3) === 'ext' || info.id.substring(0, 3) === 'fit') {
              info.z = ((<HTMLElement>(e.currentTarget)).getAttribute('data-item_z')) ? Number((<HTMLElement>(e.currentTarget)).getAttribute('data-item_z')) : 0
              const item = marietta.webcad.WebCADGlobal.LIBRARY_ITEMSLIST.get(info.id);
              info.text = marietta.webcad.WebCADGlobal.language === 'jp' ? item.name.substring(0, 10) : item.name_en.substring(0, 10);
            }
            // PCでなければステージの中央に配置する
            if (!marietta.webcad.WebCADGlobal.userAgentManager.isPC) {
              // 表示中のステージ中央座標を取得
              // var centerPoint: marietta.core.Point = marietta.webcad.util.WebCADUtil.getPointStageCenter();

              // //座標をグリッドにスナップさせる
              // var snap_unit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
              // info.x = Math.round(centerPoint.x / snap_unit) * snap_unit;
              // info.y = Math.round(centerPoint.y / snap_unit) * snap_unit;
              marietta.webcad.WebCADGlobal.webcad2Dmanager.inputCallback = (centerPoint: marietta.core.Point) => {
                info.x = centerPoint.x;
                info.y = centerPoint.y;
                const item: MonicaObject = self.itemManager.createItem(info);
                // タップで置いた UB は、置いた位置の天井高さを高さの初期値にする（PC は MonicaObject.stopFollowMouse）
                marietta.webcad.util.UnitBathUtil.fitToCeiling(item);
                marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;

                //見積リスト更新
                marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();
              };
              marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_TOUCH_MOBILE;
            } else {
              self.itemManager.createItem(info);
            }
          }
          marietta.webcad.WebCADGlobal.quotationItemList.createData();
        });
      });
    });
    // 下絵メニューイベント
    document.getElementById('btnLoadShitae').addEventListener('click', self.shitaeLoadBtnHandler);
    document.getElementById('btnEditShitae').addEventListener('click', self.shitaeEditBtnHandler);
    document.getElementById('checkShitaeVisible').addEventListener('change', self.changeShitaeVisible);
    document.getElementById('checkShitaeOpacity').addEventListener('input', self.changeShitaeOpacity);
    document.getElementById('checkShitaeOpacity').addEventListener('change', self.changeShitaeOpacity);

    // 複数カテゴリー持ちの表示/非表示
    const multiCategoryDisplay = (isShow: boolean, category: HTMLElement) => {
      const btns = category.querySelectorAll('.isMultiCategory');
      btns.forEach((btn: HTMLButtonElement) => {
        if (isShow) {
          btn.style.display = 'inline-block';
        } else {
          btn.style.display = 'none';
        }
      });
    };
    // 表示カテゴリー変更イベント
    document.querySelectorAll('.itemMenu .itemMenuHeader .itemMenuFuncBtns .categorySelect').forEach((select: HTMLSelectElement) => {
      select.addEventListener('change', (e) => {
        const { value } = e.currentTarget as HTMLSelectElement;
        const categories = select.closest('.itemMenu').querySelectorAll('.menuFrame .itemMenuGroup .itemMenuBtns');
        categories.forEach((category: HTMLElement) => {
          if (value === 'all') {
            category.style.display = 'block';
            multiCategoryDisplay(false, category);
          } else if (category.id === value) {
            category.style.display = 'block';
            multiCategoryDisplay(true, category);
          } else {
            category.style.display = 'none';
            multiCategoryDisplay(false, category);
          }
        });
      });
    });

    // 屋根作成ボタンが押された
    if (document.getElementById('btnCreateRoof') != null)document.getElementById('btnCreateRoof').addEventListener('click', self.onCreateRoofClicked);
    if (document.getElementById('btnRoofSetting') != null)document.getElementById('btnRoofSetting').addEventListener('click', self.showNokideSetting);

    // 建具一括割当
    document.getElementById('btnChangeAllFittings').addEventListener('click', () => {
      // 対象建具
      const fittings: marietta.webcad.item.Fitting[] = (marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_FITTING_NO)).getAllChildren();
      if (fittings.length < 1) return;

      marietta.webcad.WebCADGlobal.showConfirmDialog('建具を自動で割り当てますか？','建具自動割り当て', ()=>{
        for (let i:number = 0; i < fittings.length; i += 1) {
          (fittings[i] as Fitting).changeTypeToRoom();
        }
      });
    });
  }

  initView() {
    // 初期表示
    this.hideAll();
    document.getElementById('itemMenuCategories').querySelectorAll('input').forEach((elem) => {
      if (elem.checked) {
        const targetID = `#itemMenu_${elem.value}`;
        this.show(targetID);
      }
    });
  }

  /**
   * アイテム名ツールチップの表示
   */
  showTooltip = (e) => {
    // ツールチップの作成
    e.currentTarget.querySelectorAll('.itemMenuBtnIcon').forEach((elem) => {
      const itemName = elem.textContent;
      if (!itemName) return;// アイテム名がなければ処理を中止
      const el = document.createElement('div');
      el.setAttribute('class', 'tooltip');
      el.innerText = itemName;
      // ツールチップを表示
      e.currentTarget.appendChild(el);
      // 表示する座標を指定
      el.style.cssText = 'left: 0px; bottom: 0px;';
    });
  }

  /**
   * アイテム名ツールチップの削除
   */
  removeTooltip =() => {
    document.querySelectorAll('.itemMenu').forEach((element) => {
      element.querySelectorAll('.tooltip').forEach((elem) => {
        elem.remove();
      });
    });
  }

  /**
   * アイテムメニューを全て隠す
   */
  hideAll() {
    // フッターの横幅をリサイズ
    const footer: HTMLElement = document.getElementById('footerMenuQuotationList');
    footer.style.width = 'calc(100% - 50px)';
    // offsetWidth値を取得するために、displayプロパティをvisibilityに変更します。
    if (document.getElementById('itemMenuWrap').style.display === 'none') {
      document.getElementById('itemMenuWrap').style.visibility = 'hidden';
    } else {
      document.getElementById('itemMenuWrap').style.visibility = 'visible';
    }
    document.getElementById('itemMenuWrap').style.display = 'block';

    // アニメーション
    document.getElementById('itemMenuWrap').querySelectorAll('.itemMenu').forEach((_element) => {
      const element = _element;
      const w = (<HTMLElement>element).offsetWidth;
      (<HTMLElement>element).style.transform = `translateX(-${w}px)`;
    });

    // offsetWidth計算後、visibilityプロパティをdisplayに変更します
    if (document.getElementById('itemMenuWrap').style.visibility === 'hidden') {
      document.getElementById('itemMenuWrap').style.display = 'none';
    } else {
      document.getElementById('itemMenuWrap').style.display = 'block';
    }
    document.getElementById('itemMenuWrap').style.visibility = 'visible';
    // $('.itemMenu').hide();
    document.getElementById('footerMenuQuotationList').style.transform = 'translate(0px, calc(100% - 18px))';
    marietta.webcad.WebCADGlobal.quotationItemList.footerListOpen = false;
    this.currentMenuID = null;
  }

  /**
   * アイテムメニューを表示
   */
  show(targetID: string) {
    // 展開した左のメニューの横幅に合わせてフッターの横幅をリサイズ
    const footer: HTMLElement = document.getElementById('footerMenuQuotationList');
    footer.style.width = `calc(100% - ${(<HTMLElement>document.querySelector(targetID)).offsetWidth}px - 50px)`;
    // アニメーション
    (<HTMLElement>document.querySelector(targetID)).style.transform = 'translateX(-0px)';
    this._tempHideMenu = '';
    this.currentMenuID = targetID;
    const style = window.getComputedStyle(document.getElementById('footerMenuQuotationList'));
    // eslint-disable-next-line no-undef
    const matrix = new WebKitCSSMatrix(style.transform);
    document.getElementById('footerMenuQuotationList').style.transform = `translate(${(<HTMLElement>document.querySelector(targetID)).offsetWidth}px, ${matrix.m42}px)`;
    marietta.webcad.WebCADGlobal.quotationItemList.footerListOpen = (matrix.m42 === 15 || matrix.m42 === 55);
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      if (marietta.webcad.WebCADGlobal.itemManager.currentItem !== null) {
        marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
      }
    }
  }

  /**
   * セレクトボックスから表示するアイテムリストを変更する
   * class itemMenuBtns and itemMenuGroup are currently not using
   */
  updateItemList = (e) => {
    const targetName = e.currentTarget.value;
    if (targetName === 'all') {
      if (e.currentTarget.parentNode.parentNode.querySelector('.itemMenuGroup') === undefined || e.currentTarget.parentNode.parentNode.querySelector('.itemMenuGroup') === null) return;
      e.currentTarget.parentNode.parentNode.querySelector('.itemMenuGroup').querySelectorAll('.itemMenuBtns').forEach((_element) => {
        const element = _element;
        element.style.display = '';
      });
    } else {
      // 全て非表示
      if (e.currentTarget.parentNode.parentNode.querySelector('.itemMenuGroup') === undefined || e.currentTarget.parentNode.parentNode.querySelector('.itemMenuGroup') === null) return;
      e.currentTarget.parentNode.parentNode.querySelector('.itemMenuGroup').querySelectorAll('.itemMenuBtns').forEach((_element) => {
        const element = _element;
        element.style.display = 'none';
      });
      document.getElementById(`#${targetName}`).style.display = '';
    }
  }

  /**
   * 敷地アイテムメニューがカテゴリボタンの隣にくるよう表示位置調整
   */
  updateSiteItemPosition = () => {
    // アイテムカテゴリの敷地ボタンの位置取得
    const siteBtnOffset = (<HTMLElement>document.getElementById('itemMenuCategories').querySelector('#select0').nextElementSibling).getBoundingClientRect().top;
    const { headerHeight } = marietta.webcad.WebCADGlobal;
    let menuPostion = siteBtnOffset - headerHeight - (document.getElementById('itemMenu_site').offsetHeight / 4);
    if (menuPostion < 0) menuPostion = 0;
    document.getElementById('itemMenu_site').style.top = `${menuPostion}px`;
  }

  /**
   * 下絵読込ボタンが押された
   */
  shitaeLoadBtnHandler = () => {
    // 表示中のダイアログを閉じる
    marietta.webcad.WebCADGlobal.removeDialog();
    const shitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer(ITEM_MODE_NAME_ENG.MODE_SHITAE_NAME_ENG, marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, true);
    (shitaeLayer as marietta.webcad.layer.ShitaeLayer).startLoadEventHandler();
  }

  /**
   * 下絵編集ボタンが押された
   */
  shitaeEditBtnHandler = () => {
    // 表示中のダイアログを閉じる
    marietta.webcad.WebCADGlobal.removeDialog();
    const shitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer(ITEM_MODE_NAME_ENG.MODE_SHITAE_NAME_ENG, marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, true);
    if ((shitaeLayer as marietta.webcad.layer.ShitaeLayer).childList.length <= 0) {
      // "下絵読込をしてください。"
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ALERT_LOAD_DRAFT'));
      return;
    }
    (shitaeLayer as marietta.webcad.layer.ShitaeLayer).openController();
    // floorLayerのすべてのレイヤーを非表示にします
    (shitaeLayer as marietta.webcad.layer.ShitaeLayer).showHideAllFloorLayers(false);
  }

  /**
   * 下絵の表示チェックボックスが変更された
   */
  changeShitaeVisible = (e?) => {
    const param = e.currentTarget.checked;
    let tarLayer: marietta.webcad.layer.ItemLayer;
    for (let i = 1; i <= 3; i += 1) {
      tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer(ITEM_MODE_NAME_ENG.MODE_SHITAE_NAME_ENG, i, true) as marietta.webcad.layer.ItemLayer;
      if ((tarLayer as marietta.webcad.layer.ShitaeLayer).childList.length !== 0) {
        (tarLayer as marietta.webcad.layer.ShitaeLayer).changeImageVisible(param);
      }
    }
  }

  /**
   * 下絵の透過スライダーが変更された
   */
  changeShitaeOpacity = (e?) => {
    const param = Math.round(e.currentTarget.value as number) / 100;
    let tarLayer: marietta.webcad.layer.ItemLayer;
    for (let i = 1; i <= 3; i += 1) {
      tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer(ITEM_MODE_NAME_ENG.MODE_SHITAE_NAME_ENG, i, true) as marietta.webcad.layer.ItemLayer;
      if ((tarLayer as marietta.webcad.layer.ShitaeLayer).childList.length !== 0) {
        (tarLayer as marietta.webcad.layer.ShitaeLayer).changeOpactiy(param);
      }
    }
  }

  /**
   * 屋根作成ボタンがクリックされた
   */
  onCreateRoofClicked = () => {
    // 1個目の屋根であればダイアログを表示する
    const itemList: marietta.webcad.item.Roof[] = <marietta.webcad.item.Roof[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOF_NO);
    if (itemList.length > 0) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_ROOF;
    } else {
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.RoofGuidance, true, true, false);
    }
  }

  /**
   * 軒の出設定
   */
  showNokideSetting = (e) => {
    e.preventDefault();
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.NokideSetting);
  }
}
